import React, {useEffect, useState} from 'react';
import CanvasJSChart from "../dashboard/CanvasJSChart";
import SpinnerDiv from "../gdpr/ui/SpinnerDiv";
import {getPanelHeader} from "./DashboardPanelFunctions";
import {getDataFromResponse} from "../DataFunctions/BaseDataFns";
import VSFallbackComponent from "./FallbackComponent";
import {ErrorBoundary} from "react-error-boundary";
import {getUsageSummary} from "../DataFunctions/StatisticsDataFns";
import DropdownUserTypes from "./ui/DropdownUserTypes";
import DropdownSchools from "./ui/DropdownSchools";
import {getColorForUserType} from "./GraphCommonFns";

const UsageWeekSummary = (props) =>
{
    const [data, setData] = useState({loading: true, data: [], dataPoints: []})
    const [ school_id, setSchoolId ] = useState (  props.school_id) ;
    const [ user_type_id, setUserTypeId ] = useState ( 0) ;

    useEffect(() =>
    {
        getServerData(school_id, user_type_id);
    }, [school_id, user_type_id]);

    const mapDataForUserType = (arr) =>
    {
        const dataPoints = arr === undefined || arr.length === 0 ? [] : arr.map((item) => {
            const obj = {};
            obj.label = item.monkey;
            obj.y = +(item.count);
            return obj;
        })

        return dataPoints;
    }

    const toolTipContent = (e) =>
    {
        const getMonthName = (month) =>
        {
            const monthNames = ["January", "February", "March", "April", "May", "June",
                "July", "August", "September", "October", "November", "December"
            ];

            return monthNames[month];
        }

        let str = "";
        let total = 0;

        let str2;

        for (let i = 0; i < e.entries.length; i++)
        {
            const str1 = "<span style= \"color:" + e.entries[i].dataSeries.color + "\"> " + e.entries[i].dataSeries.name + "</span>: <strong>" + e.entries[i].dataPoint.y + "</strong><br/>";
            total = e.entries[i].dataPoint.y + total;
            str = str.concat(str1);
        }

        str2 = "<span style = \"color:DodgerBlue;\"><strong>" + getMonthName((e.entries[0].dataPoint.x).getMonth()) + ' ' + (e.entries[0].dataPoint.x).getFullYear() + "</strong></span><br/>";

        total = Math.round(total * 100) / 100;

        const str3 = "<span style = \"color:Tomato\">Total:</span><strong> " + total + "</strong><br/>";
        return (str2.concat(str)).concat(str3);
    }

    const getServerData = (school_id, user_type_id) =>
    {
        const selected_school = school_id === undefined ? props.school_id : school_id;

        getUsageSummary(selected_school, user_type_id, 'summary',0, 'week', (response) =>
        {
            const reportData = getDataFromResponse(response);

            const stackedData = reportData.map((myObj) =>
            {
                const item = {
                    type: "stackedColumn",
                    showInLegend: true,
                    name: myObj.name,
                    color: getColorForUserType(myObj),
                    dataPoints: mapDataForUserType(myObj.week)
                }
                return item;
            })

            setData({loading: false, dataPoints: stackedData, data: reportData});
        });
    }

    const formPanel = () =>
    {
        var options = {
            animationEnabled: true,
            exportEnabled: true,
            height: 300,
            axisY: {
                gridColor: "#B6B1A8",
                tickColor: "#B6B1A8",
            },
            toolTip: {
                shared: true,
                //content: toolTipContent
            },
            data: data.dataPoints
        };

        const onSchoolDropdownChange = ( evt, options ) =>
        {
            if ( options.action === 'select-option')
            {
                const value = evt.value;
                setSchoolId ( value) ;
            }
        };

        const onUserDropdownChange = ( evt, options ) =>
        {
            if ( options.action === 'select-option')
            {
                const value = evt.value;
                setUserTypeId ( value) ;
            }
        };

        return (
            <ErrorBoundary FallbackComponent={VSFallbackComponent}>
                <div className={'panel ' + props.panelStyle}>
                    {props.title !== '' && getPanelHeader({title: props.title})}
                    <div className='panel-body'>
                        <CanvasJSChart id='UsageWeekSummary3' options={options} uniqueId='canvasUsage3'/>
                        {data.data.length === 0 && <div> <h4>Sorry there was no data found for this choice.</h4></div>}
                    </div>

                    <div className='panel-body'>
                    { props.school_id === 0 && <div className='col-md-6'>
                        <DropdownSchools onChange={onSchoolDropdownChange}
                                         id='InputSchoolDropdown'
                                         label='Select a School'
                                         defaultValue={0}
                                         isClearable={false}
                                         value={school_id}
                                         readOnly={''}
                                         key='InputSchoolDropdown'
                                         renderErrorDiv={false}
                                         menuPlacement={'top'}/>
                        </div>}

                        <div className='col-md-6'>
                            <DropdownUserTypes onChange={onUserDropdownChange}
                                               id='InputUserDropdown'
                                               label='Select a User Type'
                                               defaultValue={user_type_id}
                                               isClearable={false}
                                               value={user_type_id}
                                               readOnly={''}
                                               key='InputUserDropdown'
                                               renderErrorDiv={false}
                                               menuPlacement={'top'}
                                               school_id={props.school_id}/>
                        </div>
                    </div>
                </div>
            </ErrorBoundary>
        )
    }

    return data.loading === true ? <SpinnerDiv/> : formPanel();
}

export default UsageWeekSummary;

UsageWeekSummary.defaultProps =
    {
        title: 'title',
        panelStyle: 'panel-default',
        data: {}
    }